// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { ArrowBackIos } from '@material-ui/icons';
import MediaQuery from 'react-responsive';

import Navigation from '../../common/Navigation/Navigation';
import styles from './styles';
import history from '../../services/history';

const PaperLayout = ({
  classes,
  label,
  children,
  contactInfo,
  hasSubPaper,
  hasBackButton,
}) => {
  const isRegister = label.toLowerCase() === 'register new account';
  const subPaper = () => {
    return (
      <div className={classes.mainContent}>
        <div className={classes.topTextContainer}>
          {hasBackButton && (
            <div
              role={'button'}
              tabIndex={0}
              onKeyPress={() => history.goBack()}
              onClick={() => history.goBack()}
              className={classes.arrowBackContainer}
            >
              <ArrowBackIos />
              <MediaQuery minWidth={500}>
                {matches => (matches
                  ? (<div className={classes.link}>Back</div>)
                  : null)}
              </MediaQuery>
            </div>)}
          <div className={classes.loginTextContainer}>
            <h3 className={classes.topText}>{label}</h3>
          </div>
        </div>
        {contactInfo}
        {!hasSubPaper && children}
        {hasSubPaper && (
          <MediaQuery minWidth={750}>
            {matches => (matches && !isRegister
              ? <Paper className={classes.formContainer}>{children}</Paper>
              : children)}
          </MediaQuery>)}
      </div>
    );
  };
  return (
    <Navigation mobileLikeIndex={false}>
      <div className={classes.mainContainer}>
        <MediaQuery minWidth={500}>
          {matches => (matches
            ? (
              <Paper className={classes.mainPaper}>
                {subPaper()}
              </Paper>)
            : subPaper()
          )}
        </MediaQuery>
      </div>
    </Navigation>
  );
};

PaperLayout.propTypes = {
  classes: PropTypes.object,
  label: PropTypes.string,
  children: PropTypes.any,
  contactInfo: PropTypes.any,
  hasSubPaper: PropTypes.bool,
  hasBackButton: PropTypes.bool,
};

PaperLayout.defaultProps = {
  classes: {},
  label: 'what is label?',
  children: null,
  contactInfo: null,
  hasSubPaper: true,
  hasBackButton: true,
};

export default withStyles(styles)(PaperLayout);
